// Product data
export const PRODUCTS = [
  {
    id: 1,
    category: "Kaffe",
    title: "Il Mingardi S",
    weight: "1000 g",
    img: "/assets/Products/Coffee/mingardi-riserva-1000.png",
    description:
      "En sammensætning af udsøgte kaffer, der allerede fra første slurk frigiver intense smagsnoter af kakao, sprøde mandler og tørret frugt.",
    origin: "Italien",
    composition: "80% Arabica - 20% Robusta",
    roast: "Medium",
    specs: { aroma: 4, body: 4, sweetness: 5, balance: 5 },
  },

  {
    id: 2,
    category: "Kaffe",
    title: "Qualità Blu",
    weight: "1000 g",
    img: "/assets/Products/Coffee/qualita-blu-1000.png",
    description:
      "En sød og harmonisk kaffeblanding med fyldig krop og noter af chokolade.",
    origin: "Italien",
    composition: "60% Arabica – 40% Robusta",
    roast: "Medium",
    specs: { aroma: 3, body: 4, sweetness: 5, balance: 4 },
  },

  {
    id: 3,
    category: "Kaffe",
    title: "Qualità Extra Bar",
    weight: "1000 g",
    img: "/assets/Products/Coffee/qualita-extra-bar-1000.png",
    description:
      "En velafbalanceret kaffeblanding med behagelig syrlighed og en vedvarende aroma, udviklet til professionelle kaffemaskiner.",
    origin: "Italien",
    composition: "80%% Arabica - 20% Robusta",
    roast: "Medium",
    specs: { aroma: 4, body: 5, sweetness: 4, balance: 4 },
  },

  {
    id: 4,
    category: "Kaffe",
    title: "Qualità Extra Bar (Per Distributori Automatici)",
    weight: "1000 g",
    img: "/assets/Products/Coffee/qualita-extra-bar-dis-1000.png",
    description:
      "En premium kaffeblanding med raffineret aroma og velbalanceret smag, udviklet til barer og professionelle kaffemaskiner.",
    origin: "Italien",
    composition: "95% Robusta - 5% Arabica",
    roast: "Medium",
    specs: { aroma: 2, body: 3, sweetness: 3, balance: 3 },
  },

  {
    id: 5,
    category: "Kaffe",
    title: "Qualità Verde Bar",
    weight: "1000 g",
    img: "/assets/Products/Coffee/qualita-verde-bar-1000.png",
    description:
      "En kraftig kaffeblanding udviklet til vending- og espressomaskiner med intens fylde og markant karakter.",
    origin: "Italien",
    composition: "80% Robusta - 20% Arabica",
    roast: "Medium",
    specs: { aroma: 3, body: 3, sweetness: 2, balance: 3 },
  },

  {
    id: 6,
    category: "Kaffe",
    title: "Qualità Espresso",
    weight: "1000 g",
    img: "/assets/Products/Coffee/qualita-espresso-1000.png",
    description:
      "En fyldig espressoblanding med tæt crema og en langvarig eftersmag.",
    origin: "Italien",
    composition: "60% Robusta – 40% Arabica",
    roast: "Medium",
    specs: { aroma: 4, body: 4, sweetness: 3, balance: 4 },
  },

  {
    id: 7,
    category: "Kaffe",
    title: "7 Origini",
    weight: "1000 g",
    img: "/assets/Products/Coffee/7-origini-1000.png",
    description:
      "En eksklusiv blanding af syv forskellige arabica-oprindelser, som giver en aromatisk og elegant smagsprofil.",
    origin: "Italien",
    composition: "100% Arabica",
    roast: "Dark",
    specs: { aroma: 4, body: 3, sweetness: 5, balance: 5 },
  },

  {
    id: 8,
    category: "Kaffe",
    title: "Qualità Rossa",
    weight: "1000 g",
    img: "/assets/Products/Coffee/qualita-rossa-1000.png",
    description:
      "En kraftig kaffeblanding med intens fylde og let træagtige noter, inspireret af afrikanske kaffetyper.",
    origin: "Italien",
    composition: "100% Robusta",
    roast: "Medium",
    specs: { aroma: 2, body: 3, sweetness: 2, balance: 4 },
  },

  {
    id: 9,
    category: "Kaffe",
    title: "Il Mingardi S Premium",
    weight: "1000 g",
    img: "/assets/Products/Coffee/mingardi-premium-1000.png",
    description:
      "Den intense og umiddelbare aroma af tørret frugt går igen i den første smagsoplevelse og baner vejen for livlige noter af kakao.",
    origin: "Italien",
    composition: "33% Arabica - 67% Robusta",
    roast: "Medium",
    specs: { aroma: 3, body: 5, sweetness: 4, balance: 4 },
  },
];
